import { createFileRoute, redirect } from '@tanstack/react-router';
import { RestaurantList } from '@/features/restaurants/RestaurantList';

export const Route = createFileRoute('/r/')({
  beforeLoad: ({ context }) => {
    if (context.convexUser.userType === 'restaurantUser') {
      const restaurantIds = context.convexUser.restaurantUser.restaurantIds;
      if (restaurantIds.length === 0) {
        throw new Error(`Restaurant 'user' has no restaurants assigned!`);
      }
      if (restaurantIds.length === 1 && restaurantIds[0]) {
        throw redirect({
          params: { restaurantId: restaurantIds[0] },
          to: '/r/$restaurantId',
        });
      }
      // Otherwise, continue and show a list of restaurants.
      // This applies to 'user' with multiple restaurants and 'admin' users.
    }
  },
  component: SelectRestaurantPage,
});

function SelectRestaurantPage() {
  return <RestaurantList className="lg:w-1/2" />;
}
